import React from 'react';

const CoinIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_84_391)'>
        <path
          d='M9.11562 19.0359C5.95144 19.0359 3.173 17.4146 1.55825 14.9565C0.616844 13.5313 0.0742188 11.8251 0.0742188 9.99457C0.0742188 4.99989 4.12094 0.953125 9.11562 0.953125H10.8794V19.0359H9.11562Z'
          fill='#FFFB12'
        />
        <path
          d='M1.83789 9.9971C1.83789 14.9932 5.88575 19.041 10.8818 19.041C15.8779 19.041 19.9323 14.9932 19.9323 9.9971C19.9323 5.00102 15.8779 0.953125 10.8818 0.953125C5.88575 0.953125 1.83789 5.00102 1.83789 9.9971Z'
          fill='#EAB308'
        />
        <path
          d='M10.8772 16.9641C10.3586 16.9641 9.85385 16.9056 9.36753 16.798L9.03125 18.8567C9.62732 18.9803 10.2446 19.0458 10.8772 19.0458C11.5119 19.0458 12.1311 18.9797 12.7291 18.8553L12.3928 16.7969C11.9046 16.9052 11.3979 16.9641 10.8772 16.9641Z'
          fill='#EAB308'
        />
        <path
          d='M10.8772 3.03475C11.3979 3.03475 11.9046 3.0937 12.3928 3.20202L12.7291 1.14353C12.1311 1.01915 11.5119 0.953125 10.8772 0.953125C10.2446 0.953125 9.62732 1.0186 9.03125 1.14221L9.36753 3.20092C9.85385 3.09328 10.3586 3.03475 10.8772 3.03475Z'
          fill='#EAB308'
        />
        <path
          d='M17.5296 7.90636L19.4776 7.16934C19.0838 5.9728 18.4481 4.88646 17.6265 3.96875L16.0137 5.28774C16.6962 6.03034 17.2197 6.92101 17.5296 7.90636Z'
          fill='#EAB308'
        />
        <path
          d='M4.23549 12.0859L2.28711 12.8231C2.68057 14.0202 3.31591 15.1069 4.13696 16.0248L5.75046 14.7052C5.06839 13.9626 4.5453 13.0717 4.23549 12.0859Z'
          fill='#EAB308'
        />
        <path
          d='M5.75069 5.28827L4.13718 3.96875C3.31595 4.88667 2.6805 5.97343 2.28711 7.17046L4.23549 7.90761C4.54519 6.92194 5.06839 6.03099 5.75069 5.28827Z'
          fill='#EAB308'
        />
        <path
          d='M17.5294 12.0859C17.2194 13.0714 16.6961 13.962 16.0137 14.7045L17.6265 16.0235C18.4479 15.1059 19.0836 14.0196 19.4774 12.823L17.5294 12.0859Z'
          fill='#EAB308'
        />
        <path
          d='M3.80664 9.99789C3.80664 13.9068 6.97369 17.0738 10.8826 17.0738C14.7915 17.0738 17.9637 13.9068 17.9637 9.99789C17.9637 6.08895 14.7915 2.92188 10.8826 2.92188C6.97369 2.92188 3.80664 6.08895 3.80664 9.99789Z'
          fill='#FFFB12'
        />
        <path
          d='M14.1724 9.87577C12.5922 9.26527 11.5283 7.87881 10.9809 5.71673C10.8892 5.35435 10.2734 5.35504 10.1815 5.7176C9.63342 7.88081 8.56915 9.26962 6.98879 9.88342C6.67047 10.0072 6.67037 10.3763 6.98869 10.4993C8.56884 11.11 9.63279 12.4962 10.1802 14.6584C10.2719 15.0208 10.8877 15.0201 10.9795 14.6576C11.5277 12.4942 12.592 11.1056 14.1722 10.4916C14.4907 10.3679 14.4907 9.99874 14.1724 9.87577Z'
          fill='#EAB308'
        />
        <path
          d='M10.594 2.9382C10.7469 2.93091 10.9071 2.92363 11.0673 2.92363C14.9773 2.92363 18.1445 6.09091 18.1445 10.0009C18.1445 13.9108 14.9773 17.0781 11.0673 17.0781C10.9071 17.0781 10.7469 17.0708 10.594 17.0635C14.2782 16.816 17.1907 13.7507 17.1907 10.0009C17.1907 6.25116 14.2782 3.18574 10.594 2.9382Z'
          fill='#A16207'
        />
      </g>
      <defs>
        <clipPath id='clip0_84_391'>
          <rect width={20} height={20} fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CoinIcon;
